import { Box, Typography, Paper, Table, TableBody, TableCell, TableHead, TableRow, Chip, TablePagination, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Business } from '@mui/icons-material';
import { useGetList } from 'react-admin';
import { useState } from 'react';
import { ListPageHeader } from '@/components/ListPageHeader';

const STATUSES = ['Active', 'Inactive'];

export const ServiceList = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [filters, setFilters] = useState<{[key: string]: string | undefined}>({});
  const { data: allServices, isLoading } = useGetList('services', { pagination: { page: 1, perPage: 1000 }, filter: filters });
  const services = allServices?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const stats = {
    total: allServices?.length ?? 0,
  };

  return (
    <Box sx={{ p: 2 }}>
      <ListPageHeader
        title="Services"
        metrics={[
          { label: 'Total', value: String(stats.total), color: 'primary.main' },
        ]}
      />
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={filters.status || ''}
            label="Status"
            onChange={e => setFilters(prev => ({ ...prev, status: e.target.value || undefined }))}
          >
            <MenuItem value="">All</MenuItem>
            {STATUSES.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
          </Select>
        </FormControl>
      </Box>
      <Paper sx={{ overflow: 'hidden' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: 'action.hover' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {services?.map((service: { id: string; name: string; description?: string; category?: string; status?: string }) => (
              <TableRow
                key={service.id}
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => navigate(`/services/${service.id}/show`)}
              >
                <TableCell>
                  <Typography variant="body2" fontWeight={500}>{service.name}</Typography>
                </TableCell>
                <TableCell>
                  <Chip label={service.category || 'General'} size="small" />
                </TableCell>
                <TableCell>
                  <Chip label={service.status || 'Active'} size="small" color={service.status === 'Active' ? 'success' : 'default'} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={allServices?.length ?? 0}
          page={page}
          onPageChange={(_, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{ borderTop: '1px solid', borderColor: 'divider' }}
        />
        {(!services || services.length === 0) && (
          <Box sx={{ p: 4, textAlign: 'center' }}>
            <Business sx={{ fontSize: 48, color: 'grey.300', mb: 1 }} />
            <Typography color="text.secondary">No services found</Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
